import { createContext } from 'react'
import type { OfferPageDispatchAction } from './offerPageStateReducer'
import noop from 'lib/function/noop'

const OfferPageDispatchContext = createContext<React.Dispatch<OfferPageDispatchAction>>(noop)

export default OfferPageDispatchContext
